/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon24Regular = forwardRef('ArrowFigureACircleLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17.25 12a.75.75 0 0 0-.75-.75H8.81l2.72-2.72a.75.75 0 0 0-1.06-1.06l-3.006 3.005a2.156 2.156 0 0 0 0 3.05l3.006 3.005a.75.75 0 1 0 1.06-1.06l-2.72-2.72h7.69a.75.75 0 0 0 .75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75ZM12 3.75a8.25 8.25 0 1 1 0 16.5 8.25 8.25 0 0 1 0-16.5Z" })));
});
